import React from "react";
import { useWalletModal } from "@/hooks/use-wallet-modal";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ChevronLeft } from "lucide-react";

export function ExternalWalletModal() {
  const { isOpen, closeWalletModal } = useWalletModal();

  return (
    <Dialog open={isOpen} onOpenChange={closeWalletModal}>
      <DialogContent className="max-w-4xl h-[90vh] p-0 flex flex-col">
        <DialogHeader className="px-4 py-2 border-b">
          <div className="flex items-center">
            <button
              onClick={closeWalletModal}
              className="text-foreground hover:text-muted-foreground transition-colors"
              aria-label="Go back"
            >
              <ChevronLeft className="h-6 w-6" />
            </button>
          </div>
        </DialogHeader>
        <div className="flex-1 overflow-hidden">
          <iframe
            src="https://wallet.fixorium.com.pk"
            className="w-full h-full border-0"
            title="Fixorium Wallet"
            allow="clipboard-read; clipboard-write"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-presentation"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
